import React, { useEffect, useState } from "react";
import Close from "../../../../../../images/Close.svg";
import { Button } from "../../../../../../stories/Button/Button";
import Add from "./Add";
import List from "./List";
import { Title } from "../../../../../../stories/Title/Title";
import { tableHeaderForm } from "../../../../../../utils/formTypes";
import {
  AddProjectHeader,
  UpdateProjectHeader,
} from "../../../masters/projects/queries/mutations";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddProjectHeaderResult,
  AddProjectHeaderVar,
  AtsProjectHeaders,
  UpdateProjectHeaderResult,
  UpdateProjectHeaderVar,
} from "../../../masters/projects/queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import {
  CheckProjectAnyInitHeader,
  GetAtsProjectHeadersById,
  GetProjectsHeaders,
  GetProjectsTableHeaderCount,
} from "../../../masters/projects/queries/queries";
import { emptyMessage } from "../../../../../../utils/constants";
import { msgType, opWithIdType } from "../../../../../../utils/types";
import { Operation } from "../../../../../../utils/Enum.types";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { nodeVar } from "../../../../../../utils/commonQueryTypes";
interface props {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddTableStructure = ({ setModal }: props) => {
  const [formData, setFormData] = useState<tableHeaderForm>({
    header: "",
    initData: false,
    dataType: "",
    status: false,
  });

  const [message, setMessage] = useState<msgType>(emptyMessage);

  const [operation, setOperation] = useState<opWithIdType>({
    id: 0,
    operation: Operation.CREATE,
  });

  const { customer_id, projectID } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const [GetHeaderNode, { data }] = useLazyQuery<
    { node: AtsProjectHeaders },
    nodeVar
  >(GetAtsProjectHeadersById);

  const [AddProject, { loading }] = useMutation<
    AddProjectHeaderResult,
    AddProjectHeaderVar
  >(AddProjectHeader, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdateProject, { loading: updateLoading }] = useMutation<
    UpdateProjectHeaderResult,
    UpdateProjectHeaderVar
  >(UpdateProjectHeader, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  useEffect(() => {
    if (operation.operation === Operation.UPDATE && operation.id) {
      GetHeaderNode({
        variables: {
          id: operation.id,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setFormData({
            header: data.node.header,
            initData: data.node.initData,
            dataType: data.node.dataType,
            status: data.node.status,
          });
        }
      });
    }
  }, [operation.id, GetHeaderNode, data, operation.operation]);

  const handleSubmit = () => {
    if (customer_id && projectID)
      if (operation.operation === Operation.CREATE) {
        AddProject({
          variables: {
            customerID: customer_id,
            projectID: projectID,
            header: formData.header,
            initData: formData.initData,
            dataType: formData.dataType,
            user_details: user_details,
          },
          refetchQueries: [
            {
              query: GetProjectsTableHeaderCount,
              variables: {
                customerID: customer_id,
                empID: user_details.id,
              },
            },
            {
              query: GetProjectsHeaders,
              variables: {
                customerID: customer_id,
                projectID: projectID,
              },
            },
            {
              query: CheckProjectAnyInitHeader,
              variables: {
                customerID: customer_id,
                projectID: projectID,
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.AddProjectHeader) {
            setMessage({
              flag: true,
              message: "Table Header added successfully",
              operation: Operation.CREATE,
            });
          }
        });
      } else {
        UpdateProject({
          variables: {
            customerID: customer_id,
            projectHeaderID: operation.id,
            header: formData.header,
            initData: formData.initData,
            dataType: formData.dataType,
            user_details: user_details,
            status: formData.status,
          },
          refetchQueries: [
            {
              query: GetProjectsTableHeaderCount,
              variables: {
                customerID: customer_id,
                empID: user_details.id,
              },
            },
            {
              query: GetProjectsHeaders,
              variables: {
                customerID: customer_id,
                projectID: projectID,
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.UpdateProjectHeader) {
            setMessage({
              flag: true,
              message: "Table Header updated successfully",
              operation: Operation.UPDATE,
            });
          }
        });
      }
  };

  const handleClear = () => {
    setFormData({
      header: "",
      initData: false,
      dataType: "",
      status: true,
    });
  };
  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
      setOperation({
        id: 0,
        operation: Operation.CREATE,
      });
    }
    setMessage(emptyMessage);
  };

  return (
    <div className="add-wp-ts">
      <div className="add-wp-ts__title">
        <Title>
          {operation.operation === Operation.CREATE ? "Add" : "Update"} Table
          Structure
        </Title>
        <img src={Close} alt="" onClick={() => setModal(false)} />
      </div>
      <div className="add-wp-ts__block row g-0">
        <div className="add-wp-ts__block--left col">
          <Add
            formState={{
              formData,
              setFormData,
            }}
            operation={operation.operation}
          />
        </div>
        <div className="add-wp-ts__block--right col">
          <List
            states={{
              operation,
              setOperation,
            }}
          />
        </div>
      </div>
      <Button
        mode="save"
        loading={loading || updateLoading || formData.header === ""}
        onClick={handleSubmit}
      />
      <Button
        mode="clear"
        loading={loading || updateLoading}
        onClick={handleClear}
      />
      <Button
        mode="cancel"
        loading={loading || updateLoading}
        onClick={() => setModal(false)}
      />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default AddTableStructure;
